module.exports = __webpack_public_path__ + "static/fact-counter-bg-f90f0d32d197c1dfc09d39f6d10dd6a2.jpg";